import { apiRequest } from 'utils/request'

export const getReleaseNotes = () => apiRequest(`/release-notes`)

export const postReleaseNote = ({ requestBody }) =>
  apiRequest({
    method: 'POST',
    uri: `/release-notes`,
    body: requestBody,
  })
